<template>
  <div class="option-selector step" :class="{active: active, selected: selected, unlocked: unlocked}">
    <div class="step-header" @click="setActive">
      <span class="title">{{optionGroup.name}}</span>
      <div class="value secondary-font" v-if="selected">{{selectedOptions[optionGroup.code].name}}</div>
      <icon-check />
    </div><!-- /.step-header -->
    <div class="step-body" v-if="active">
      <div class="description-wrapper" v-if="optionGroup.description">
        <p class="description secondary-font small">{{optionGroup.description}}</p>
      </div><!-- /.description-wrapper -->

      <div class="flex-container is-wrapped">
        <div
          class="flex-third option"
          :class="{selected: selectedOptions[optionGroup.code].optionCode == option.optionCode, disabled: option.isSize && !option.isValid}"
          :id="`img-option-${option.optionCode}`"
          v-for="option in optionGroup.options"
          :key="`option_${option.optionCode}`"
          @click="selectOption(option)"
        >
          <div class="layout-inner">
            <div
              class="option-image"
              :style="{backgroundImage: 'url(' + option.optionData.ImageUrl + ')' }"
            ></div><!-- /.option-image -->
            <div class="name-wrap" v-if="option.name">
              <!-- If a radio button is required -->

              <!-- <div class="radio-button-wrap">
                <div class="radio-button" :class="{selected: selectedOptions[optionGroup.code] == option}"></div>
              </div>-->

              <div class="option-value secondary-font small">
                {{option.name}}
                <div class="blue option-price" v-if="option.price > 0">+${{option.price}}</div>
              </div><!-- /.option-value -->
            </div><!-- /.name-wrap -->
          </div><!-- /.layout-inner -->
        </div><!-- /.flex-third -->
      </div><!-- /.flex-container -->
    </div><!-- /.step-body -->
  </div><!-- /.option-selector -->
</template>

<script>
import { mapActions, mapState } from "vuex"
import { validateImageOptions } from "@/helpers/validation"

export default {
  name: "ImageOptions",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    unlocked: {
      type: Boolean,
      required: true
    },
    optionGroup: {
      type: Object,
      required: true,
      validator: function(value) {
        return validateImageOptions(value);
      }
    }
  },
  methods: {
    ...mapActions(["setSelectedOptions", "setActiveGroup", "setDeactiveGroup"]),
    selectOption(option) {
      // Prevent invalid sizes from being selected
      if (!(option.isSize && !option.isValid)) {
        this.setSelectedOptions({
          var: this.optionGroup.code,
          val: {
            ...option,
            selected: true,
          }
        })
      }
    },
    setActive() {
      if (this.unlocked) {
        if (this.active) {
          this.setDeactiveGroup()
        }
        else {
          this.setActiveGroup(this.optionGroup)
        }
      }
    }
  },
  computed: {
    ...mapState(["selectedOptions"])
  }
}
</script>
